const VerifyDocumentCredabilityActionTypes = {
  VERIFY_DOCUMENT_CREDABILITY_REQUEST: 'VERIFY_DOCUMENT_CREDABILITY_REQUEST',
  VERIFY_DOCUMENT_CREDABILITY_SUCCESS: 'VERIFY_DOCUMENT_CREDABILITY_SUCCESS',
  VERIFY_DOCUMENT_CREDABILITY_FAILURE: 'VERIFY_DOCUMENT_CREDABILITY_FAILURE'
}

export default VerifyDocumentCredabilityActionTypes